import InfrastructureDashboard from "./InfrastructureDashboard";

export default InfrastructureDashboard;
